module.exports = __webpack_public_path__ + "static/media/SortedNewDown.d1bbe061.svg";